module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('app-landing-page-layout', [(_vm.show_staging_protection_page) ? _c('staging-password', {
    on: {
      "acceptStaging": function($event) {
        _vm.staging_password_is_correct = true
      }
    }
  }) : [_c('div', {
    staticClass: "flex h-screen overflow-y-auto"
  }, [_c('div', {
    staticClass: "mx-auto mt-12"
  }, [_c('div', {
    staticClass: "flex justify-center"
  }, [_c('img', {
    staticClass: "w-24",
    attrs: {
      "src": "/static/logos/parlay_logo.svg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "sign-in-box my-5 box-border shadow-sm p-9 border-1 rounded bg-white"
  }, [(_vm.authenticator_method === null) ? _c('div', [(!_vm.reset_pwd_page) ? _c('div', [_c('span', {
    staticClass: "mb-4 flex justify-center font-bold text-lg"
  }, [_vm._v("\n                Sign In to Parlay\n              ")]), _vm._v(" "), _c('div', [_c('google-button'), _vm._v(" "), _c('microsoft-button')], 1), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center my-4 text-gray-400"
  }, [_c('div', {
    staticClass: "line"
  }, [_c('span', [_vm._v("OR")])])]), _vm._v(" "), _c('span', {
    staticClass: "font-semibold"
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "bg-input text-sm text-gray-500 flex-grow outline-none px-4 py-2 w-full rounded border-none",
    staticStyle: {
      "border": "none !important"
    },
    attrs: {
      "type": "email"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login(_vm.user)
      }, function($event) {
        _vm.error_message = null
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex justify-between mt-5"
  }, [_c('span', {
    staticClass: "font-semibold"
  }, [_vm._v("Password")]), _vm._v(" "), _c('span', {
    staticClass: "text-pinky cursor-pointer text-xs",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleResetPwd(true)
      }
    }
  }, [_vm._v("\n                  Forgot password?\n                ")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "bg-input text-sm text-gray-500 flex-grow outline-none px-4 py-2 w-full rounded border-none",
    staticStyle: {
      "border": "none !important"
    },
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login(_vm.user)
      }, function($event) {
        _vm.error_message = null
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "h-5 text-xs text-red-500 italic"
  }, [_vm._v("\n                " + _vm._s(_vm.error_message) + "\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "mb-6 px-4 py-2 w-full bg-pinky hover:bg-pinky-dark rounded cursor-pointer text-white font-semibold",
    on: {
      "click": function($event) {
        return _vm.login(_vm.user)
      }
    }
  }, [_vm._v("\n                Continue\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center text-xs"
  }, [_c('span', {
    staticClass: "text-gray-400"
  }, [_vm._v(" Don´t have an account?")]), _vm._v(" "), _c('router-link', {
    staticClass: "ml-2 text-pinky",
    attrs: {
      "to": {
        name: 'signup'
      }
    }
  }, [_vm._v("\n                  Sign Up\n                ")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.reset_pwd_page) ? _c('div', [_c('p', {
    staticClass: "mb-4 flex justify-center font-bold text-lg"
  }, [_vm._v("\n                Recover Password\n              ")]), _vm._v(" "), _c('p', {
    staticClass: "font-semibold"
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reset_pwd_email),
      expression: "reset_pwd_email"
    }],
    staticClass: "bg-input text-sm text-gray-500 flex-grow outline-none px-4 py-2 w-full rounded",
    attrs: {
      "type": "email"
    },
    domProps: {
      "value": (_vm.reset_pwd_email)
    },
    on: {
      "keyup": [function($event) {
        _vm.error_message = null
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.sendEmail.apply(null, arguments)
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reset_pwd_email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "h-5 text-xs text-red-500 italic"
  }, [_vm._v("\n                " + _vm._s(_vm.error_message) + "\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "mb-6 px-4 py-2 w-full bg-pinky hover:bg-pinky-dark rounded cursor-pointer text-white font-semibold",
    on: {
      "click": _vm.sendEmail
    }
  }, [_vm._v("\n                Send Email\n              ")]), _vm._v(" "), _c('a', {
    staticClass: "flex justify-center text-xs text-pinky",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleResetPwd(false)
      }
    }
  }, [_vm._v("\n                Back to login\n              ")])]) : _vm._e()]) : _c('div', [_c('div', {
    staticClass: "flex justify-center items-center mb-5"
  }, [_c('div', {
    staticClass: "w-12 h-12 flex items-center rounded-full justify-center bg-gray-100 shadow"
  }, [_c('i', {
    staticClass: "fa-solid text-base text-blueGray-800 fa-mobile"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col space-y-3 mb-7"
  }, [_c('h4', {
    staticClass: "text-base text-center text-gray-800 font-semibold"
  }, [_vm._v("Two Factor Authentication")]), _vm._v(" "), _c('span', {
    staticClass: "text-center"
  }, [_vm._v("Enter the six digit code displayed on your authenticator app")])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col space-y-2 mb-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formattedInput),
      expression: "formattedInput"
    }],
    staticClass: "px-3 py-2 rounded border border-solid border-gray-200",
    attrs: {
      "maxlength": "7",
      "placeholder": "Enter six code generated..."
    },
    domProps: {
      "value": (_vm.formattedInput)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formattedInput = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center w-full mb-4"
  }, [_c('button', {
    staticClass: "px-3 py-2 text-white w-full bg-primary hover:bg-primary-dark rounded",
    on: {
      "click": function($event) {
        return _vm.handleVerifyTwoFactor(_vm.user)
      }
    }
  }, [_vm._v("Continue to Parlay")])]), _vm._v(" "), _c('div', {
    staticClass: "flex hover:underline cursor-pointer justify-center items-center",
    on: {
      "click": function($event) {
        return _vm.handleBackLogin()
      }
    }
  }, [_c('a', [_vm._v("Back to Login")])])])])])]), _vm._v(" "), (_vm.show_confirmation_dialog) ? _c('RecoveryPassword', {
    on: {
      "close": function($event) {
        _vm.show_confirmation_dialog = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.open_ai_alert) ? _c('div', {
    staticClass: "absolute top-0 p-5 w-full flex justify-center items-center text-white",
    staticStyle: {
      "background": "rgba(26, 4, 29, 0.9)"
    }
  }, [_vm._v("\n      Sign in or sign up for your free Parlay teacher account to run this\n      class discussion!\n    ")]) : _vm._e()]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-7471a11c!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/authentication/login/login.vue
// module id = 2307
// module chunks = 61